import React, { useEffect, useState } from "react";
import { salaryService } from "../../../../api/services/salaryService";
import { useAppDispatch, useAppSelector } from "../../../../infra/hooks";
import { setEmployeeAssignGovtTax } from "../../../../infra/aggregates/myProfile/salaryAggregates/empGovtTaxSlice";
import { setGovtTaxLoader } from "../../../../infra/aggregates/myProfile/salaryAggregates/salaryLoadersSlice";

interface PropsValues {
  setEmpAssignGovtTaxData: (data: any) => void;
  setCurrency: (data: any) => void;
}

function DTOGovtTax({ setEmpAssignGovtTaxData, setCurrency }: PropsValues) {
  const selector = useAppSelector((state) => state.authSlice);
  const govtTax = useAppSelector((state) => state.empGovtTaxSlice.empGovtTax);
  const current_currency = useAppSelector((state) => state.authSlice.currency);
  const dispatch = useAppDispatch();
  async function getEmployeeGovtTax(companyId: number, empId: number) {
    dispatch(setGovtTaxLoader(true));
    const response: any = await salaryService.getEmployeeAssignGovtTax(
      companyId,
      empId
    );

    if (response.response == "success") {
      const empGovtTax: any = response?.data;

      dispatch(setEmployeeAssignGovtTax(empGovtTax));
      /* Passing Props to Controller */

      setEmpAssignGovtTaxData(empGovtTax);
      setCurrency(current_currency);
      dispatch(setGovtTaxLoader(false));
    } else {
      dispatch(setGovtTaxLoader(false));
      return;
    }
  }
  useEffect(() => {
    getEmployeeGovtTax(selector.company_id, selector.emp_id);
  }, []);

  useEffect(() => {
    setEmpAssignGovtTaxData(govtTax);
    setCurrency(current_currency);
  }, [govtTax]);
  return <></>;
}
export default DTOGovtTax;
